@for (attribute of attributes; track attribute.code) {
<div class="w-12 p-b-2"
     [style.bottom.em]="-1"
     dragScroll>
    @for (option of attribute.options; track option.value) {
    <label class="inline-block b-a cursor-pointer option pe-auto-s"
           [ngClass]="isPicked(attribute, option) ? 'b-col-4' : 'b-col-t'"
           (click)="pick(attribute, option)">
        <img class="w-12"
             [dfImage]="option.product.data.image"
             [ratio]="'4/5'"
             [dfSrcset]="'40w, 60w, 80w, 100w'">
    </label>
    }
</div>
}